/* eslint-disable camelcase */
export default class CommissionVoucher {
  app_company_id = null;
  quarter_from = null;
  quarter_to = null;
  sales_rep_id = null;
  sales_order_id = null;
  amount_paid = 0;
  amount_carried_over = 0;
  balance_from_previous_period = 0;
  product_code = '';
  sales_order = {
    partner_id: null
  };
  sales_order_qty = 0;
  unit_price = 0;
  commission_rate = 0;
  commission_invoiced = 0;
  commission_shipped = 0;
  commission_open = 0;
}



// WEBPACK FOOTER //
// ./resources/assets/js/_shared/models/CommissionVoucher.js